import { motion } from "framer-motion";
import { ACHIEVERS } from "@/data";

const surname = (full) => full.trim().split(/\s+/).pop();
const sorted = [...ACHIEVERS].sort((a, b) => surname(a.name).localeCompare(surname(b.name), "el"));

export default function Achievers() {
  return (
    <section id="achievers" data-testid="achievers-section" className="py-20 md:py-32 bg-secondary/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14">
          <div className="max-w-2xl">
            <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Πίνακας Επιτυχόντων</div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
              Οι επιτυχόντες μας.
            </h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Αλφαβητική κατάσταση των μαθητών μας που πέτυχαν στη σχολή των ονείρων τους. Ευχαριστούμε για την εμπιστοσύνη!
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-border">
          {sorted.map((a, i) => (
            <motion.div
              key={a.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: (i % 6) * 0.04 }}
              data-testid={`achiever-${i}`}
              className="group flex items-baseline gap-4 border-r border-b border-border bg-white px-6 py-5 hover:bg-primary transition-colors duration-300"
            >
              <div>
                <div className="font-heading font-bold text-base sm:text-lg group-hover:text-white transition-colors">{a.name}</div>
                <div className="text-sm text-muted-foreground group-hover:text-white/80 transition-colors mt-0.5">{a.school}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
